import { render } from "./singleService.vue?vue&type=template&id=37019ade&scoped=true"
import script from "./singleService.vue?vue&type=script&lang=js"
export * from "./singleService.vue?vue&type=script&lang=js"

import "./singleService.vue?vue&type=style&index=0&id=37019ade&lang=css"
import "./singleService.vue?vue&type=style&index=1&id=37019ade&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37019ade"]])

export default __exports__